import React from 'react';

import cx from 'classnames';

import { ReactComponent as ArrownDownIcon } from '../../assets/arrow-down.svg';
import { ReactComponent as CheckIcon } from '../../assets/check-icon.svg';
import styles from './styles.module.scss';

const RubricSelector = ({
  options,
  selected,
  onSelect,
  isOpen,
  onToggle,
  placeholder = 'Select a grading rubric...'
}) => {
  return (
    <div className={styles.fieldSection}>
      <div className={styles.fieldLabel}>
        <span>Grading Rubric</span>
      </div>
      <div className={styles.customSelect} onClick={onToggle}>
        <div className={styles.selectedRubricText}>
          {selected ? (
            <>
              <span className={styles.rubricLabel}>{selected.text}</span>
              {selected.subtext && (
                <span className={styles.rubricSubtext}>{selected.subtext}</span>
              )}
            </>
          ) : (
            <span className={cx(styles.rubricLabel, styles.placeholderText)}>
              {placeholder}
            </span>
          )}
        </div>

        <ArrownDownIcon className={styles.chevron} />

        {isOpen && (
          <div className={styles.rubricDropdownOptions}>
            {options.map((opt) => {
              const isSelected = selected?.key === opt.key;

              return (
                <div
                  key={opt.key}
                  className={cx(styles.rubricOption, {
                    [styles.selected]: isSelected
                  })}
                  onClick={(e) => {
                    e.stopPropagation();
                    onSelect(opt);
                    onToggle(); // Close dropdown after selection
                  }}
                >
                  <div className={styles.checkWrapper}>
                    {isSelected && <CheckIcon className={styles.checkIcon} />}
                  </div>
                  <div className={styles.itemContent}>
                    <span className={styles.optLabel}>{opt.text}</span>
                    {opt.subtext && (
                      <span className={styles.optSubtext}>{opt.subtext}</span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default RubricSelector;
